var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({
    'font-family': (_vm.siteConfig && _vm.siteConfig.navBottomBorderColor === 'orange')
      ? '\'Open Sans\', sans-serif'
      : 'myriad-pro, sans-serif'
  })},[_c('router-view'),_c('ContentPreview')],1)}
var staticRenderFns = []

export { render, staticRenderFns }